import React, { useState } from "react";
import { Card, Row, Space, Button } from "@masterteam/mt-design-react";

import ChartCard from "../ChartCard";
import { useIsAr } from "../../../../Hooks";

import { ReactComponent as LevelOneIcon } from "../../../../assets/images/level-one.svg";
import { ReactComponent as ArrowIcon } from "../../../../assets/images/arrowpointdwn.svg";

import "./style.scss";

const Objective = ({ item, kpiStatuses, projectStatuses }) => {
  const [isAr] = useIsAr();
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Space
      direction="vertical"
      size="medium"
      key={item.ID}
      className="objective-wrapper"
    >
      <Card className="objective-wrapper__item-card">
        <Space align="center">
          <LevelOneIcon fill={isOpen ? "var(--primary-color)" : "#B5B5B5"} />

          <div>{isAr ? item?.ArabicName : item?.EnglishName}</div>
        </Space>
        <Button
          variant="dark"
          shape="circle"
          backgroundColor="transparent"
          fill=""
          Icon={ArrowIcon}
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
        />
      </Card>

      {isOpen ? (
        <Row size="large" align="stretch">
          <ChartCard
            statuses={kpiStatuses?.filter((e) => e.Code !== "NA")}
            data={item}
            title="dashboards.objective-kpis-performance"
          />
          <ChartCard
            statuses={projectStatuses}
            data={item}
            isProject
            title="dashboards.objective-projects-performance"
          />
        </Row>
      ) : null}
    </Space>
  );
};

export default Objective;
